import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import ChallengeChat from './ChallengeChat'
import { userDtoSelector } from '../Settings/store/SettingsSelectors'

const mapStateToProps = (state: IGlobalState, ownProps: any) => ({
  goalId: ownProps.match.params.goalId,
  userDto: userDtoSelector(state),
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ChallengeChat)
